import React from 'react';
import styled from 'styled-components/macro';
import { RouteComponentProps } from 'react-router-dom';
import { findIndex } from 'ramda';

import { TabBar, TabItem } from '@deeptrue-frontend/ui';
import RouterProvider from 'components/RouterProvider/RouterProvider';
import { useFormatMessage } from 'components/IntlProvider';

const StyledTabItem = styled(TabItem)``;

const TabBarWrapper = styled.div`
  margin: 3.5rem 0 2rem;
  width: 100%;
`;

const { withRouter, ROUTES } = RouterProvider;

const urls = [
  ROUTES.ADMIN.ORGANIZATIONS.LIST,
  ROUTES.ADMIN.TEMPLATES.SURVEYS.MAIN,
  ROUTES.ADMIN.TEMPLATES.BRIEFINGS.MAIN,
  ROUTES.ADMIN.PRODUCTS.LIST,
  ROUTES.ADMIN.WORKBENCHES.LIST,
  ROUTES.ADMIN.ASSETS.LIST,
];

const checkPathname = (pathname: string) => {
  const itemIndex = findIndex((url: string) => new RegExp(url).test(pathname))(
    urls
  );

  return itemIndex || 0;
};

const AdminMenu = ({ history, location }: RouteComponentProps) => {
  const t = useFormatMessage();

  return (
    <TabBarWrapper>
      <TabBar
        selectedIndex={checkPathname(location.pathname)}
        onSelect={(value: number) => history.push(urls[value])}
      >
        <StyledTabItem
          title={t('dashboard.menu.organizations', 'Organizations')}
        />
        <StyledTabItem
          title={t('dashboard.menu.templates.survey', 'Survey Templates')}
        />
        <StyledTabItem
          title={t('dashboard.menu.templates.briefing', 'Briefing Templates')}
        />
        <StyledTabItem title={t('dashboard.menu.products', 'Products')} />
        <StyledTabItem title={t('dashboard.menu.workbenches', 'Workbenches')} />
        <StyledTabItem title={t('dashboard.menu.assets', 'Assets')} />
      </TabBar>
    </TabBarWrapper>
  );
};

export default withRouter(AdminMenu);
